import gql from 'graphql-tag';

const AVAILABILITIES_QUERY = `
  cityAvailabilitiesStatistics(cityId: $cityId, propertyType: $propertyType) {
    month
    year
    percentage
    delta
  }
`;

const PRICES_STATISTICS = `
  cityPricesStatistics(cityId: $cityId, propertyType: $propertyType) {
    month
    year
    averagePrice
    delta
  }
`;

const TENANT_PROFILES_STATISTICS = `
  cityTenantStatistics(cityId: $cityId) {
    ageDistribution {
      type
      percentage
    }
    occupationType {
      type
      percentage
    }
    nationality {
      nationality
      percentage
      countryName (locale: $locale)
    }
  }
`;

const USER_INTERACTIONS_STATISTICS = `
  cityUserInteractionStatistics(cityId: $cityId) {
    propertyType
    percentage
  }
`;

const QUERY_AVAILABILITIES_STATISTICS = gql`
  query CityAvailabilitiesStatistics($cityId: String!, $propertyType: String) {
    ${AVAILABILITIES_QUERY}
  }
`;

const QUERY_PRICES_STATISTICS = gql`
  query CityPricesStatistics($cityId: String!, $propertyType: String) {
    ${PRICES_STATISTICS}
  }
`;

const QUERY_ALL_STATISTICS = gql`
  query CityStatistics($cityId: String!, $propertyType: String, $locale: String) {
    ${AVAILABILITIES_QUERY}
    ${PRICES_STATISTICS}
    ${TENANT_PROFILES_STATISTICS}
    ${USER_INTERACTIONS_STATISTICS}
  }
`;

export const getAvailabilitiesCityStatistics =
  client =>
  ({ cityId, propertyType }) =>
    client.query({
      query: QUERY_AVAILABILITIES_STATISTICS,
      variables: {
        cityId,
        propertyType
      },
      fetchPolicy: 'cache-first'
    });

export const getPricesCityStatistics =
  client =>
  ({ cityId, propertyType }) =>
    client.query({
      query: QUERY_PRICES_STATISTICS,
      variables: {
        cityId,
        propertyType
      },
      fetchPolicy: 'cache-first'
    });

export const getAllCityStatistics =
  client =>
  ({ cityId, propertyType, locale }) =>
    client.query({
      query: QUERY_ALL_STATISTICS,
      variables: {
        cityId,
        propertyType,
        locale
      },
      fetchPolicy: 'cache-first'
    });
